import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { SubAreaModel } from '../models/subarea.model';
import { map } from 'rxjs/operators';


const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class SubAreaService {


constructor( private http: HttpClient ) { }


get token(): string {
  return localStorage.getItem('token') || '';
}

get headers() {
 return {
   headers: {
    'x-token': this.token
   }
};
}




  cargarSubAreasPaginacion( pagina: number = 0) {

  const url = `${ base_url }/subareas/paginacion?pagina=` + pagina;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, subareas: SubAreaModel[] }) => resp.subareas )
                  );

  }
  cargarSubAreas() {

  const url = `${ base_url }/subareas`;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, subareas: SubAreaModel[] }) => resp.subareas )
                  );

  }



  crearSubArea( name: string ) {

  const url = `${ base_url }/subareas`;
  return this.http.post( url, { name }, this.headers);

  }


  actualizarSubArea( _id: string, name: string ) {

  const url = `${ base_url }/subareas/${ _id }`;
  return this.http.put( url, { name }, this.headers);

  }


  borrarSubArea( _id: string ) {

  const url = `${ base_url }/subareas/${ _id }`;
  return this.http.delete( url, this.headers);

  }



}
